import { useEffect } from 'react';
import { initializeSocket } from '../services/socket';
import { useTeamsStore } from '../stores/teamsStore';
import { usePlayersStore } from '../stores/playersStore';
import { Player, Team } from '../types';

export const useStoreSync = () => {
  useEffect(() => {
    // Populate stores on mount if empty
    useTeamsStore.getState().fetchTeams();
    usePlayersStore.getState().fetchPlayers();

    const socket = initializeSocket();

    const handlePlayerUpdated = (data: Player) => {
      usePlayersStore.getState().updatePlayer(data);
    };

    const handlePlayerAdded = (data: Player) => {
      usePlayersStore.getState().addPlayer(data);
    };

    const handlePlayerDeleted = (data: any) => {
      const id = typeof data === 'string' ? data : data?._id || data?.playerId;
      if (id) usePlayersStore.getState().removePlayer(id);
    };

    const handlePlayerSold = (data: any) => {
      const player = data?.player || data;
      if (player?._id) {
        usePlayersStore.getState().updatePlayer(player);
      }
      const team = data?.team;
      if (team?._id) {
        useTeamsStore.getState().updateTeam(team);
      }
    };

    const handlePlayerMarkedUnsold = (data: Player) => {
      usePlayersStore.getState().updatePlayer(data);
    };

    const handleTeamUpdated = (data: Team) => {
      useTeamsStore.getState().updateTeam(data);
    };

    const handleTeamCreated = (data: Team) => {
      useTeamsStore.getState().addTeam(data);
    };

    const handleTeamDeleted = (data: any) => {
      const id = typeof data === 'string' ? data : data?._id || data?.teamId;
      if (id) useTeamsStore.getState().removeTeam(id);
    };

    const handleDataReset = () => {
      useTeamsStore.setState({ lastFetched: null });
      usePlayersStore.setState({ lastFetched: null });
      useTeamsStore.getState().fetchTeams(true);
      usePlayersStore.getState().fetchPlayers(true);
    };

    const handlePlayerRemovedFromTeam = (data: { player: any; team: any }) => {
      if (data.player?._id) {
        usePlayersStore.getState().updatePlayer(data.player);
      }
      if (data.team?._id) {
        useTeamsStore.getState().updateTeam(data.team);
      }
    };

    socket.on('playerUpdated', handlePlayerUpdated);
    socket.on('playerAdded', handlePlayerAdded);
    socket.on('playerDeleted', handlePlayerDeleted);
    socket.on('playerSold', handlePlayerSold);
    socket.on('playerMarkedUnsold', handlePlayerMarkedUnsold);
    socket.on('teamUpdated', handleTeamUpdated);
    socket.on('teamCreated', handleTeamCreated);
    socket.on('teamDeleted', handleTeamDeleted);
    socket.on('dataReset', handleDataReset);
    socket.on('playerRemovedFromTeam', handlePlayerRemovedFromTeam);

    return () => {
      socket.off('playerUpdated', handlePlayerUpdated);
      socket.off('playerAdded', handlePlayerAdded);
      socket.off('playerDeleted', handlePlayerDeleted);
      socket.off('playerSold', handlePlayerSold);
      socket.off('playerMarkedUnsold', handlePlayerMarkedUnsold);
      socket.off('teamUpdated', handleTeamUpdated);
      socket.off('teamCreated', handleTeamCreated);
      socket.off('teamDeleted', handleTeamDeleted);
      socket.off('dataReset', handleDataReset);
      socket.off('playerRemovedFromTeam', handlePlayerRemovedFromTeam);
    };
  }, []);
};
